<a [href]="railPlatforLink" target="_blank" class="d-flex">
  <rx-icon class="mr-1" [name]="'train'" [fill]="'white'" />
  <div class="mr-1 rail-platform-name">Roomex Rail</div>
  <rx-icon [name]="'arrow-right'" [fill]="'white'" />
</a>
